import { ITemplateInfoView } from 'apis/models';
import PreviewIframe from 'components/PreviewIframe';
import { Tag } from 'm-ui';
import React, { FC } from 'react';
import './index.less';

interface IPreviewProps {
  record: ITemplateInfoView;
}
const Preview: FC<IPreviewProps> = (props) => {
  const { record } = props;
  return (
    <div className="preview-content flex">
      <div className="p-devices">
        <PreviewIframe src={record.playUrl} />
      </div>
      <div className="p-detail">
        <div className="pd-title ellipsis">{record.name}</div>
        <div className="pd-line">
          <div className="pl-label">所属行业</div>
          <div className="pl-content">
            {record.categorys.map((item) => (
              <Tag key={item}>{item}</Tag>
            ))}
          </div>
        </div>
        <div className="pd-line">
          <div className="pl-label">模板描述</div>
          <div className="pl-content">{record.desc}</div>
        </div>
        <div className="pd-line">
          <div className="pl-label">预览链接</div>
          <div className="pl-content">
            <a href={record.playUrl} target="_blank" rel="noreferrer">
              点击在浏览器中查看
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preview;
